import React, { useCallback } from "react";
import { GlobalBox } from 'components/Box/GlobalBox'
import { useSelector, useDispatch } from "react-redux";
import { useSearch } from "hooks/useSearch";
import AssessmentIcon from '@mui/icons-material/Assessment';
import { TableInputs } from "components/CardTable/TableInputs"
import { dateValidator } from "helpers/dateValidator";
import { newDate } from "helpers/dateTools";
import { LoadingComponent } from "components/Loading/LoadingComponent";
import { setReportNotesTransferredFilters, getReportNotesTransferredAction } from "redux/actions/Reports/reportNotesTransferred/reportNotesTransferredActions";

export const ReportNotesTransferredView = () => {
  const dispatch = useDispatch();
  const { setSnackbar } = useSearch();
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { startDate, endDate, station } = useSelector(({ reportNotesTransferred }) => reportNotesTransferred);

  const handleSubmit = useCallback((e, isPdf = true) => {
    e.preventDefault()
    if (!station?.id) { setSnackbar("Falta seleccionar planta.", 'warning'); return; }
    if (dateValidator(startDate, endDate, 31, setSnackbar)) return
    dispatch(getReportNotesTransferredAction({ startDate, endDate, station, isPdf }))
  }, [startDate, endDate, station]);


  return (
    <GlobalBox title="Reporte de Notas traspasadas" icon={<AssessmentIcon />} >
      <TableInputs
        reducer="reportNotesTransferred"
        dates
        stations
        maxDate={newDate()}
        dispatchAction={setReportNotesTransferredFilters}
        submitAction={handleSubmit}
        submitSecond={(e) => handleSubmit(e, false)}
        submitButtonName="PDF"
        loading={isLoadingComp?.loadingReportNotesTransferred}
      />
      {isLoadingComp?.loadingReportNotesTransferred && <LoadingComponent />}
    </GlobalBox>
  );
};
